import { createContext } from 'react';

const PhoneCallerContext = createContext();
PhoneCallerContext.displayName = 'PhoneCallerContext';

export default PhoneCallerContext;
